module.exports = __webpack_public_path__ + "img/mx.91567a0.webp";